import { useCallback } from "react";
import { useOfferFiltersDispatch, useOfferFiltersState, } from "../context/OfferFiltersContext";
import { getListingLocation, navigateToListingUrl } from "../utils/listing-url";
import { buildSubmitUrl } from "../utils/buildSubmitUrl";
export function useOfferFilterSubmit() {
    const { selectedState } = useOfferFiltersState();
    const dispatch = useOfferFiltersDispatch();
    return useCallback((options) => {
        var _a;
        const stateToApply = (_a = options === null || options === void 0 ? void 0 : options.state) !== null && _a !== void 0 ? _a : selectedState;
        const { pathname, search } = getListingLocation();
        dispatch({ type: "commit_selected", payload: options === null || options === void 0 ? void 0 : options.state });
        dispatch({ type: "close_overlay" });
        navigateToListingUrl(buildSubmitUrl(stateToApply, pathname, search));
    }, [dispatch, selectedState]);
}
